<template>
	<div class="gamelist-withe">
		<cIndex></cIndex>
		<div class="gamelist">
		<div class="gamelist-container">
			<div class="user-content">
				<h5>
					<b>{{this.usergame}}</b>，您好：
				</h5>
				<p>
					点击测试内容，进行您的脑健康测试吧！
				</p>
			</div>
			 <ul>
				<li v-for="(item,key,index) in gameListInfo" class="gameTitle-button" @click="imgIcon(item.gameUrl,item.id)">
					<dl>
						<img :src="item.icon" alt="图片">
						<p class="game" v-if="item.status==1">
							<b>已测试</b>
						</p>
					</dl>
					<p>{{item.name}}</p>
					<p>{{item.brainCapacity}}</p>
				</li>
			</ul> 
		</div> 
		 <div class="gamelist-footer" v-if="this.gameStatus==1">
			<p>是否结束本次检测？如果确认结束，请点击确认按钮，完成检测，并可查看检测报告</p>
			<router-link to = "/viewreport" tag="span" style = "cursor: pointer;">确认</router-link>	
		</div> 
	 </div>
	</div>
</template>
<script>
import cIndex from '@/components/header'
	const components = {
		cIndex
	}
	export default {
		components:components,
		data(){
			return {
				usergame:{},
				gameListInfo:{},
				userEid:{},
				gametoken:{},
				gameStatus:{},
			}
		},
		created(){
			const gameEid = localStorage.getItem('eid')
			if(gameEid == '' || gameEid == undefined||gameEid == null){
				 location.href = "/#/"
           		
			}else{
				this.$http.post(urls.urltest + '/game/getMyGames.json',{
					token:localStorage.getItem('token'),
					eid:gameEid
				}).then(function(res){
					console.log(res.body);
					this.usergame = res.body.name;
					this.gametoken = res.body.token;
					this.gameListInfo = res.body.object;
					this.gameStatus = res.body.gameStatus;
					$(window).focus(function() {
						location.reload();
					});
				})
			}
		},
		methods:{
			imgIcon(gameUrl, gameID) {
				var eid = localStorage.getItem('eid')
				console.log(gameID)
				console.log(eid)
				window.open ( gameUrl+'?eid='+eid+'&egid='+gameID)
				//window.open ( 'http://127.0.0.1:8020/shuzibijiao/index.html?eid='+this.userEid+ '&token='+ this.gametoken+'&gid='+gameID+'&rid='+2)
			}
		}
	}
</script>
<style lang="scss">
	@import "../styles/core/reset.scss";
	.gamelist-withe{
		width: 100%;
		height: 100%;
		background: #fff;
		overflow: hidden;
			 .gamelist{
			width: 100%;
			height: 100%;
			background: #fff;
			overflow: hidden;
			.gamelist-footer{
				p{
					font-size: .14rem;
					color: #999;
					text-align: center;
					padding: .2rem 0;
				}
				span{
					text-align: center;
					width: 1.2rem;
					height: .35rem;
					background: #467DE5;
					color: #fff;
					font-size: .16rem;
					display: block;
					line-height: .35rem;
					margin: auto;
				}
			}
		}
		.gamelist-container{
			width: 10.20rem;
			height: 3.72rem;
			margin: 1.58rem auto;
			.user-content{
				h5{
					font-size: .18rem;
					color: #555;
					padding: .09rem 0;
					line-height: .31rem;
				}
				p{
					font-size: .16rem;
					color: #444;
					padding: .09rem 0 .6rem 0;
				}
			}
			ul {
				@include flexbox;
				li {
					padding-right: .6rem;
					dl {
						width: 2rem;
						height: 2rem;
						overflow: hidden;
						display: block;
						position: relative;
						img {
							position: relative;
							width: 100%;
							cursor: pointer;
						}
						.game {
							height: 100%;
							width: 100%;
							opacity: 0.7;
							background: #000000;
							border: 0 solid #979797;
							position: absolute;
							left: 0;
							top: 0;
							b {
								position: absolute;
								height: 100%;
								width: 100%;
								font-size: 12px;
								color: #FFFFFF;
								padding: 0.92rem 0.82rem 0.91rem 0.82rem;
							}
						}
					}
					p {
						font-size: .14rem;
						color: #444444;
						line-height: .25rem;
						padding-top: .14rem;
						&:last-child {
							font-size: 12px;
							color: #888888;
							padding: 0;
						}
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// gamelist.vue?3e9e43ac